import React, { useState } from 'react'
import {useSelector} from "react-redux";

export default function Redirect({value, onDataChanged, props}) {
  const allowSameWindowRedirect = useSelector(state => state.redirectSettings?.allowSameWindowRedirect)
  const domainName = useSelector(state => state.domainName)
  const digitalOceanDomain = useSelector(state => state.digitalOceanDomain)

  let actuallyAllowSameWindowRedirect = allowSameWindowRedirect
  if (typeof (allowSameWindowRedirect) == "undefined") {
    actuallyAllowSameWindowRedirect = true
  }

  console.debug("REDIRECT SAME WINDOW", {allowSameWindowRedirect, actuallyAllowSameWindowRedirect})
  const [redirectUrl, setRedirectUrl] = useState(value.redirect_url)
  console.log({domainName, digitalOceanDomain, redirectUrl})
  const showWarning = domainName && digitalOceanDomain && redirectUrl && (redirectUrl.replace("https://", "").replace("http://", "").indexOf(digitalOceanDomain) >= 0 || redirectUrl.replace("https://", "").replace("http://", "").indexOf(domainName) >= 0)

  return <div>
    <hr/>
    {actuallyAllowSameWindowRedirect && <>
      <div className="form-check">
        <input type="checkbox"
               className="form-check-input"
               checked={(value.redirect_in_same_window == "true" || value.redirect_in_same_window == true)}
               onChange={(event) => {
                 onDataChanged({
                   ...value,
                   redirect_in_same_window: event.target.checked
                 })
               }}
        />
        <label className="form-check-label">Redirect in same window.</label>
      </div>
      <hr/>
    </>}
    <h5 className="hotspot-setting-header">Redirect Url</h5>
    <div className="hotspot-setting-info">
      This is the url which users will be redirected to if the click the hotspot.
    </div>
    <div className="form-group">
      <input
        className="form-control"
        type="text"
        placeholder="https://your.link/..."
        value={value.redirect_url}
        onChange={(event) => {
          setRedirectUrl(event.target.value)
          onDataChanged({
            ...value,
            redirect_url: event.target.value
          })
        }}
      />
      {showWarning &&
        <div className="mt-2 alert alert-danger">
          <p>
            <i className="fa fa-exclamation-triangle"></i>{" "}
            <b>Please use a relative URL!</b>
          </p>
          Example: {" "}
          {redirectUrl.replace("https://", "").replace("http://", "").replace(digitalOceanDomain, "").replace(domainName, "")}
        </div>
      }
    </div>
  </div>;
}
